import { useQuery } from '@tanstack/react-query';
import { eventsApi } from '../api/events';

export function useEvent(id: string | undefined) {
  return useQuery({
    queryKey: ['event', id],
    queryFn: () => eventsApi.get(id!),
    enabled: !!id,
  });
}
